import(/* webpackMode: "eager" */ "/vercel/path0/apps/portal/src/app/global-error.tsx");
